export const hotelStaffActionTypes = {
  API_RESPONSE_SUCCESS: 'API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: 'API_RESPONSE_ERROR',
  INSERT_HOTEL_STAFF: 'INSERT_HOTEL_STAFF',
  GET_ALL_STAFF: 'GET_ALL_STAFF',
  DELETE_STAFF: 'DELETE_STAFF',
};

export interface Staff {
  staff_id: number;
  hotel_id: number;
  user_id: number;
  full_name: string;
  mobile_number: string;
  email: string;
  designation: string | null;
  is_active: boolean;
  joined_at: string | Date | null;
  exited_at: string | Date | null;
  created_at: string | Date;  // ISO string or Date
  updated_at: string | Date;  // ISO string or Date
}


export interface hotelStaffReducerState {
  staff: Staff[]; 
  // available_rooms: any[];
  loading: boolean;
  error: string | null;
}
